@if (showField$ | async) {
  <div class="divider-container">
    @if (!field.attrs?.hideLabel) {
      <h4>{{field.label | translate}}</h4>
    }
    <mat-divider></mat-divider>
  </div>
}
